import Api from "shared/service/api/api";

// actions
export const LOAD_INTEGRATIONS = "loadIntegrations";
export const CREATE_EDEONE_API_KEY = "createEdeoneApiKey";

// mutations
export const SET_API_EDEONE = "setApiEdeone";
export const SET_UNISENDER = "setUnisender";
export const SET_JUSTCLICK = "setJustclick";
export const SET_SENDPULSE = "setSendpulse";
export const SET_SENLER = "setSenler";
export const SET_PIXEL = "setPixel";

const state = {
  api_edeone: {
    id: "",
    key: "",
    url: "",
  },
  unisender: {
    service: "unisender",
    key: "",
  },
  justclick: {
    service: "justclick",
    login: "",
    key: "",
  },
  sendpulse: {
    service: "sendpulse",
    login: "",
    key: "",
  },
  senler: {
    service: "senler",
    vk_group_id: "",
    key: "",
  },
  pixel: {
    service: "pixel",
    vk_id: "",
    fb_id: "",
    ya_id: "",
  },
};

const getters = {
  api_edeone: (state) => state.api_edeone,
  unisender: (state) => state.unisender,
  justclick: (state) => state.justclick,
  sendpulse: (state) => state.sendpulse,
  senler: (state) => state.senler,
  pixel: (state) => state.pixel,
};

const actions = {
  [LOAD_INTEGRATIONS]({ commit }) {
    return new Promise((resolve) => {
      Api.integration
        .get()
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          const data = response.data;

          commit(SET_API_EDEONE, data.api_edeone);
          commit(SET_UNISENDER, data.unisender);
          commit(SET_JUSTCLICK, data.justclick);
          commit(SET_SENDPULSE, data.sendpulse);
          commit(SET_SENLER, data.senler);
          commit(SET_PIXEL, data.pixel);
          resolve(true);
        })
        .catch(() => {
          resolve(false);
        });
    });
  },
  [CREATE_EDEONE_API_KEY]({ commit }) {
    return new Promise((resolve) => {
      Api.integration
        .createEdeoneApiKey()
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          commit(SET_API_EDEONE, response.data);
          resolve(true);
        })
        .catch(() => {
          resolve(false);
        });
    });
  },
};

const mutations = {
  [SET_API_EDEONE](state, api_edeone) {
    state.api_edeone.id = api_edeone.id;
    state.api_edeone.key = api_edeone.key;
    // state.api_edeone.url = api_edeone.url;
  },
  [SET_UNISENDER](state, unisender) {
    state.unisender.key = unisender.key;
  },
  [SET_JUSTCLICK](state, justclick) {
    state.justclick.key = justclick.key;
    state.justclick.login = justclick.user_id;
  },
  [SET_SENDPULSE](state, sendpulse) {
    state.sendpulse.key = sendpulse.key;
    state.sendpulse.login = sendpulse.user_id;
  },
  [SET_SENLER](state, senler) {
    state.senler.key = senler.key;
    state.senler.vk_group_id = senler.vk_group_id;
  },
  [SET_PIXEL](state, pixel) {
    state.pixel.vk_id = pixel.vk_id;
    state.pixel.fb_id = pixel.fb_id;
    state.pixel.ya_id = pixel.ya_id;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
